export class ServerError<T> extends Error {
  public status: number;
  public response: T;
  constructor({
    status,
    message,
    response,
  }: {
    status: number;
    message?: string;
    response: T;
  }) {
    super(message);
    this.response = response;
    this.status = status;
  }
}

export const isServerError = <T>(error: any): error is ServerError<T> => {
  return (
    error &&
    typeof error === 'object' &&
    error?.hasOwnProperty('response') &&
    error?.hasOwnProperty('status')
  );
};
